import type { ComponentProps } from 'react';
import Button from '@mui/material/Button';

import { palette } from '../theme.ts';

const QUIET_SX = {
  backgroundColor: 'transparent',
  color: palette.textPrimary,
  border: `1.5px solid ${palette.quietBorder}`,
  fontWeight: 700,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: palette.quietHover,
    borderColor: palette.quietBorderHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: 'transparent',
    borderColor: 'divider',
    color: palette.textMuted,
  },
} as const;

export type QuietButtonProps = ComponentProps<typeof Button>;

export function QuietButton({ sx, ...props }: Readonly<QuietButtonProps>): React.JSX.Element {
  return <Button {...props} sx={[QUIET_SX, ...(Array.isArray(sx) ? sx : [sx])]} />;
}

export default QuietButton;
